import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import { parseEvent } from 'utils/eventUtils'
import { RefetchContext } from 'lib/utils/refetchContext'
import EventDetailsDialog from 'pages/pga-coach/bookings/events/event-details-dialog'
import { GET_GROUP_EVENT_DETAILS } from 'pages/pga-coach/bookings/events/query'

const GroupEventDetails = ({ slug, onClose }) => {
  const { data, loading, error, refetch } = useQuery(GET_GROUP_EVENT_DETAILS, {
    variables: { slug, includeCanceled: true },
    skip: !slug,
  })
  const [view, setView] = useState('detail')
  const groupEvent = data?.currentUser?.groupEvents?.[0]

  if (!slug) return null

  if (groupEvent) {
    return (
      <RefetchContext.Provider value={refetch}>
        <EventDetailsDialog
          isOpen={view}
          setIsOpen={next => {
            if (next) return setView(next)
            setView('detail')
            onClose()
          }}
          event={parseEvent(groupEvent)}
        />
      </RefetchContext.Provider>
    )
  }

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      {loading ? (
        <DialogContent>
          <Box display="flex" justifyContent="center" p={2}>
            <CircularProgress aria-label="Loading event details" />
          </Box>
        </DialogContent>
      ) : (
        <>
          <DialogTitle>Event details</DialogTitle>
          <DialogContent>
            <Typography>
              {error
                ? 'We could not load this event. Please try again.'
                : 'This event could not be found.'}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={onClose}>
              Close
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

export default GroupEventDetails
